// extracted by mini-css-extract-plugin
module.exports = {"teamReportContainer":"team-report_teamReportContainer__3f4ty","teamReport":"team-report_teamReport__TNA6y"};